module.exports = __webpack_public_path__ + "static/media/couleurfestival.ba1a3b3b.jpg";